"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = pageBuilder;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _browserHistory = _interopRequireDefault(require("react-router/lib/browserHistory"));
var _Shell = _interopRequireDefault(require("./Shell"));
var _getStoreAndRoutes2 = _interopRequireDefault(require("./getStoreAndRoutes"));
var render = function render(Component, props) {
  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(Component, props), document.getElementById('app'));
};
function pageBuilder(createRoutes) {
  var injectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultLocale = arguments.length > 2 ? arguments[2] : undefined;
  var pageProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // WARNING: This is the client side version of the page rendering,
  // see thunderball/server/browser/render for the server side version.
  // These need to remain somewhat the same.

  // If injectors isn't an array, make it an array with what was passed in
  // This allows for a single injector object
  if (!Array.isArray(injectors)) {
    /* eslint no-param-reassign: 0 */
    injectors = [injectors];
  }
  // support ES modules or commonjs
  createRoutes = createRoutes["default"] || createRoutes;
  injectors = injectors.map(function (x) {
    return x["default"] || x;
  });

  // Initial state is set isomorphically at first
  var initialState = (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' ? window.__INITIAL_STATE__ : {};
  var _getStoreAndRoutes = (0, _getStoreAndRoutes2["default"])(initialState, createRoutes, _browserHistory["default"], {
      adjustUrlOnReplay: false
    }, injectors, pageProps),
    store = _getStoreAndRoutes.store,
    routes = _getStoreAndRoutes.routes,
    history = _getStoreAndRoutes.history;
  var shellProps = {
    injectors: injectors,
    store: store,
    history: history,
    pageProps: pageProps,
    routes: routes,
    defaultLocale: defaultLocale
  };
  if (module.hot && typeof module.hot.accept === 'function') {
    module.hot.accept('./Shell', function () {
      var NextShell = require('./Shell');
      render(NextShell, shellProps);
    });
  }
  render(_Shell["default"], shellProps);
}
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/thunderball-client/lib/render/pageBuilder.js
// module id = 137
// module chunks = 25